import styled from 'styled-components'

export const Container = styled.div`
  max-width: 100%;
  height: 100%;
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
`

export const TitleWrapper = styled.div`
  flex: 1;
`

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px 0;
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
`

export const Content = styled.div`
  position: relative;
  padding-left: 0;
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
`

export const ErrorMessage = styled.div`
  padding: 20px;
  background: rgba(255, 59, 48, 0.1);
  border: 1px solid var(--danger);
  border-radius: 8px;
  color: var(--danger);
  text-align: center;
  margin: 20px 0;
`
